import React from 'react';
interface SectionLabelProps {
  text: string;
  className?: string;
}
export function SectionLabel({
  text,
  className = ''
}: SectionLabelProps) {
  return <div className={`text-rosegold font-inter text-sm font-semibold uppercase tracking-[0.2em] text-center mb-6 ${className}`} data-id="element-56">
      {text}
    </div>;
}